import { LOCATION_CHANGE } from 'connected-react-router';
import { createMiddleware } from '../../../shared/redux';
import {
    acceptResendSignUpConfirmation,
    acceptSignUpConfirmation,
    raiseSignUpConfirmationUnknownException,
    rejectSignUpConfirmation,
    SIGN_UP_CONFIRMATION_ACCEPTED,
    SIGN_UP_CONFIRMATION_REJECTED,
    SIGN_UP_CONFIRMATION_RESEND_REJECTED,
    SIGN_UP_CONFIRMATION_RESEND_REQUESTED,
    SIGN_UP_CONFIRMATION_SUBMITTED,
} from './sign-up-confirmation-state';
import * as AuthService from '../auth-service';
import { acceptSignUp, getSignUpData } from '../sign-up/sign-up-state';
import { match } from '../../../shared/utils/match';
import { ROUTES } from '../auth.constants';
import { redirectToHome, redirectToSignIn } from '../auth-base-state';
import gaTrackerEvent from '../../../shared/utils/analyticsTracker';

export const signUpConfirmationMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [ROUTES.SIGN_UP_CONFIRMATION]: state => (
            AuthService.currentAuthenticatedUser()
                .then(() => redirectToHome())
                .catch(() => {
                    const data = getSignUpData(state);
                    return !data?.username
                        ? redirectToSignIn()
                        : null;
                })
        ),
    }),

    [SIGN_UP_CONFIRMATION_SUBMITTED]: (_, action) => {
        gaTrackerEvent(
            'AuthSignUp',
            'ConfirmEmail',
        );

        return (
            AuthService
                .confirmSignUp({ username: action.payload.username, code: action.payload.code })
                .then(user => acceptSignUpConfirmation({ user }))
                .catch(error => rejectSignUpConfirmation({ error }))
        );
    },
    [SIGN_UP_CONFIRMATION_ACCEPTED]: (_, action) => {
        gaTrackerEvent(
            'AuthSignUp',
            'ConfirmEmailAccepted',
        );

        return acceptSignUp({ user: action.payload.user });
    },
    [SIGN_UP_CONFIRMATION_REJECTED]: (_, action) => {
        gaTrackerEvent(
            'AuthSignUp',
            'ConfirmEmailRejected',
        );

        return (
            raiseSignUpConfirmationUnknownException({ message: action.payload.error.message })
        );
    },
    [SIGN_UP_CONFIRMATION_RESEND_REQUESTED]: (_, action) => {
        gaTrackerEvent(
            'AuthSignUp',
            'ConfirmEmailResend',
        );

        return (
            AuthService.resendSignUpConfirmation({ username: action.payload.username })
                .then(() => acceptResendSignUpConfirmation())
                .catch(error => rejectSignUpConfirmation({ error }))
        );
    },
    [SIGN_UP_CONFIRMATION_RESEND_REJECTED]: (_, action) => (
        raiseSignUpConfirmationUnknownException({ message: action.payload.error.message })
    ),
});
